import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { SearchOff } from '@mui/icons-material';
import { tokens } from '../../theme';

const T = tokens;

// The one empty state (K2.3 pts 12, 14), styled once with the theme tokens: centred and padded, the icon above the
// text. Every screen passes its own words, the learner home's empty sections too (K2.3 pt 14.1).
// Removed 2 Nov 2026 (K2.3 pt 14.1): 'to match the empty boxes on the learner dashboard ... muted text', which no longer
// holds: those boxes use this component.
// - title={null}: the message stands alone, with no icon (the Insights pages' sentences, N5 pt 8).
// - framed={false}: no frame of its own, for a place that already has one (a table cell, a card, a section frame).
// - The look of 'We don't have content for this yet.' (K2.3 pt 14.1): the theme's warning text (status warnText) on its
//   pale box (status warnBg), framed as that message is; unframed, the pale box without a border. tone="neutral" keeps
//   the grey look, for Insights' all-clear sentences, since good news isn't a warning. Removed 2 Nov 2026 (K2.3 pt
//   14.1): grey text on a white box for every empty state.
// Removed 23 Oct 2026 (K2.3 pt 14): the classes empty-state, empty-state-icon, empty-state-title and
// empty-state-message, defined nowhere, so it showed as a bordered box with the icon jammed in its corner.
const EmptyState = ({
  title = 'Nothing found',
  message = 'Try adjusting your search criteria or filters.',
  icon: Icon = SearchOff,
  actionLabel,
  onAction,
  framed = true,
  tone = 'warn',
}) => {
  const warn = tone !== 'neutral';
  return (
  <Box
    sx={{
      textAlign: 'center',
      padding: title ? '28px 20px' : '20px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      // Across the whole row when it sits in a grid (the catalogue and the course and path grids); no effect elsewhere.
      gridColumn: '1 / -1',
      ...(framed ? {
        background: warn ? T.color.status.warnBg : T.color.bgPrimary,
        border: `0.5px solid ${warn ? T.color.status.warnText : T.color.borderTertiary}`,
        borderRadius: T.radius.lg,
      } : warn ? {
        background: T.color.status.warnBg,
        borderRadius: T.radius.lg,
      } : {}),
    }}
  >
    {title && Icon && <Icon sx={{ fontSize: 28, color: warn ? T.color.status.warnText : T.color.textTertiary, marginBottom: '10px' }} />}
    {title && (
      <Typography sx={{ fontSize: T.font.size.md, fontWeight: T.font.weight.medium, color: warn ? T.color.status.warnText : T.color.textPrimary, fontFamily: T.font.family, marginBottom: '4px' }}>
        {title}
      </Typography>
    )}
    {message && (
      <Typography sx={{ fontSize: title ? T.font.size.sm : T.font.size.md, color: warn ? T.color.status.warnText : T.color.textSecondary, fontFamily: T.font.family, lineHeight: 1.6, maxWidth: '520px' }}>
        {message}
      </Typography>
    )}
    {actionLabel && onAction && (
      <Button variant="outlined" onClick={onAction} sx={{ mt: 2 }}>
        {actionLabel}
      </Button>
    )}
  </Box>
  );
};

export default EmptyState;
